
import { v4 as uuidv4 } from 'uuid';

/**
 * Generates a random state parameter for OAuth flows
 * 
 * @returns A random string for state parameter
 */
export function generateRandomState(): string {
  return uuidv4().replace(/-/g, '');
}

/**
 * Alias for generateRandomState for backward compatibility
 * @deprecated Use generateRandomState instead
 */
export function generateState(): string {
  return generateRandomState();
}

/**
 * Validates a callback state against a stored state
 * 
 * @param callbackState State from the callback URL
 * @param storedState State stored during initiation
 * @returns Boolean indicating if states match
 */
export function validateCallbackState(callbackState: string | null, storedState: string | null): boolean {
  if (!callbackState || !storedState) {
    return false;
  }
  
  return callbackState === storedState;
}
